export default __webpack_public_path__ + "static/media/30.8adc8cef.svg";